import React from 'react';
import Const from 'constants';
import {Table as ClassicTable} from './classic';
import {Table as ShowDownTable} from './showdown';

const PlayersList = {
    get(sportConfig) {
        if (sportConfig.isGameTypeShowDown()) {
            return ShowDownTable;
        } else if (sportConfig.isGameTypeClassic()) {
            return ClassicTable;
        }

        throw new Error(`get ERR: unknown game type ${sportConfig.getGameType()}`);
    },
};

export {PlayersList};
